import React, { useState } from "react";
import shortid from "shortid";
import { Table } from "react-bulma-components";
import { Box } from "react-bulma-components";
import Part from "./Part";
import { Button } from "react-bulma-components";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Icon } from "react-bulma-components";
import { Link } from "react-router-dom";
import {getPartCustomerCost, getWorkItemCustomerCost, getWorkItemEstimateCustomerCost} from "../../utils";
import ModifyQuoteModal from "./ModifyQuoteModal";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import WorkTypePicker from "../Job/WorkTypePicker";

function WorkSection(props) {
  const [modifyQuoteModalOpen, setModifyQuoteModalOpen] = useState(false);
  const handleChange = e => {
    const newWorkItem = getNewWorkItem(e);
    props.update_work(newWorkItem, props.index);
  };

  const getNewWorkItem = e => {
    let chargeable =
      e.target.name === "chargeable"
        ? e.target.value
        : props.workItem.chargeable;
    let customer = chargeable ? props.hireCustomer : props.customer;

    let newWorkItem = { ...props.workItem, [e.target.name]: e.target.value };
    if (
      e.target.name === "estimated_labour_hours" ||
      e.target.name === "chargeable"
    ) {
      newWorkItem = getWorkItemEstimateCustomerCost(props.vehicle, props.supplier, newWorkItem, customer, props.appDefaults.default_labour_estimate_rate);
    }
    if (props.quote.duplicate && (e.target.name === "labour_hours" || e.target.name === "chargeable")){
      // as the quote does not have a workshop props.supplier will always be undefined
      newWorkItem = getWorkItemCustomerCost(props.vehicle, props.supplier, newWorkItem, customer, false);
    }
    return newWorkItem;
  };

  const readyForInvoicing = () => {
    // if(
    //     ((!props.workItem.work_type)
    //     ||
    //     (!props.workItem.job))
    //     &&
    //     (
    //         !(props.workItem.work_type && props.workItem.work_type.free_of_charge && !props.workItem.work_type.approval_needed)
    //         ||
    //         !(props.workItem.work_type && props.workItem.work_type.free_of_charge && props.workItem.work_type.approval_needed && props.workItem.approval_received)
    //         ||
    //         !(props.workItem.job_workshop_invoice_number)
    //     )
    // ) {
    if(!props.workItem.work_type || !props.workItem.job || !props.workItem.job_approved){
      return false;
    }
    if(props.workItem.work_type && props.workItem.work_type.free_of_charge && props.workItem.work_type.approval_needed && !props.workItem.approval_received){
      return false;
    }
    if(!props.workItem.work_type.free_of_charge && !props.workItem.job_workshop_invoice_number){
      return false;
    }

    // if(props.workItem.work_type && props.workItem.work_type.free_of_charge && !props.workItem.work_type.approval_needed){
    //   console.log("yes");
    // }
    for (let i = 0; i < props.workItem.parts.length; i++) {
      if (
        !props.workItem.parts[i].part_invoice_number &&
        !props.workItem.parts[i].from_stock &&
        !props.workItem.parts[i].backorder &&
        !props.workItem.parts[i].backorder_expected_date
      ) {
        return false;
      }
    }
    return true;
  };

  const onToggleOriginalQuote= () => {
    let newWorkItem = {
      ...props.workItem,
      added_after_quote: !props.workItem.added_after_quote
    };
    props.update_work(newWorkItem, props.index);
  };

  const handleCheck = (e) => {
    const toUpdate = {
      target: {
        name:e.target.name,
        value: e.target.checked
      }
    };
    handleChange(toUpdate);
  }

  const onCheck = () => {
    const newWorkItem = getNewWorkItem({
      target: {
        name: "chargeable",
        value: !props.workItem.chargeable
      }
    });
    newWorkItem.parts = props.workItem.parts.map(part => {
      return {
        ...part,
        customer_cost: getPartCustomerCost(
          part,
          newWorkItem.chargeable ? props.hireCustomer : props.customer,
          props.appDefaults
        )
      };
    });
    props.update_work(newWorkItem, props.index);
  };

  const addPart = e => {
    props.update_work(
      {
        ...props.workItem,
        parts: props.workItem.parts.concat({
          key: shortid.generate(),
          name: "",
          cost: 0,
          estimated_cost: 0,
          supplier: {},
          date_ordered: "",
          part_invoice_number: "",
          part_number: "",
          from_stock: false,
          backorder_expected_date: "",
          to_be_ordered: false,
          cost_override: false,
          customer_cost: 0,
          estimated_customer_cost: 0
        })
      },
      props.index
    );
  };

  const updateParts = (part, index) => {
    let newParts = [...props.workItem.parts];
    newParts.splice(index, 1, part);
    const newWorkItem = {
      ...props.workItem,
      parts: newParts
    };
    props.update_work(newWorkItem, props.index);
  };

  const removePart = (index, part) => {
    if (!part.part) {
      let newParts = [...props.workItem.parts];
      newParts.splice(index, 1);
      const newWorkItem = {
        ...props.workItem,
        parts: newParts
      };
      props.update_work(newWorkItem, props.index);
    } else {
      NotificationManager.error(
        "This Part is linked to a Job Card. You must delete the Part on the Job Card first!"
      );
    }
  };

  let allMatches = props.workItem.estimate_matches_job;

  let className = props.workItem.work ? "box-border-amber" : "";
  className = readyForInvoicing() ? "box-border-green" : className;
  className = props.workItem.work && !allMatches ? "box-border-red" : className;


  const handleTypeSelect = e => {
    let value = e.target.value === "BLANK" ? null : props.workTypeObjects[e.target.value];
    const toUpdate = {
      target: {
        name: "work_type",
        value: value
      }
    };
    handleChange(toUpdate);
  }

  const formatJobStatus = (data) => {
    // Takes a string
    let splitData = data.split("_");
    let returnString = "";
    splitData.forEach((word) => {
      returnString = returnString+" "+word
    });
    return returnString;
  }

  return (
    <Box className={className}>
      <Columns>
        <Columns.Column>
          {props.workItem.job ? (
            <Link to={`/editjob/${props.workItem.job}`}>
              <Button>Job Card - {props.workItem.job} - {props.workItem.workshop}</Button>
            </Link>
          ) : (
            <p>No Job Card has been created for this item!</p>
          )}
        </Columns.Column>
        <Columns.Column>
          {readyForInvoicing() ? (
            <p>This item is ready for invoicing</p>
          ) : (
            <p>This item is not ready for invoicing</p>
          )}
        </Columns.Column>
        <Columns.Column>
          {allMatches ? (
            <p>The job card associated with this item matches the estimate</p>
          ) : props.workItem.work ? (
            <p>
              The job card associated with this item does not match the
              estimate!
            </p>
          ) : (
            ""
          )}
        </Columns.Column>
        <Columns.Column>
          <p>{props.workItem.job ? formatJobStatus(props.workItem.job_status) : ""}</p>
        </Columns.Column>
        <Columns.Column>
          <Form.Label>Not Needed</Form.Label>
          <Form.Checkbox
            name={"not_being_done"}
            checked={props.workItem.not_being_done}
            onChange={handleCheck}
            disabled={props.workItem.job}
          />
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Description</Form.Label>
              <Form.Input
                data-testid="description"
                type="text"
                name="description"
                onChange={handleChange}
                value={props.workItem.description}
                required
                disabled={props.workItem.not_being_done || props.disabled}
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Charge Customer 2</Form.Label>
              <Form.Checkbox
                type="checkbox"
                name="chargeable"
                onChange={onCheck}
                checked={props.workItem.chargeable}
                disabled={!props.hireCustomer || props.workItem.not_being_done || props.disabled}
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Est. Labour Hours</Form.Label>
              <Form.Input
                data-testid="estimated_labour_hours"
                className="input"
                type="number"
                name="estimated_labour_hours"
                onChange={handleChange}
                value={String(props.workItem.estimated_labour_hours)}
                disabled={props.workItem.not_being_done || props.disabled || props.quote.duplicate}
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Est. Labour Cost</Form.Label>
            <Form.Control>
              <Form.Input
                className="input"
                type="number"
                name="estimated_labour_cost"
                onChange={handleChange}
                value={String(props.workItem.estimated_labour_cost)}
                disabled={props.workItem.not_being_done || props.disabled || props.quote.duplicate}
              />
              <Icon align={"left"} className={"small-icon"}>
                <FontAwesomeIcon icon={faPoundSign}/>
             </Icon>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Est. Labour Charge</Form.Label>
            <Form.Control>
              <Form.Input
                className="input"
                type="number"
                name="estimated_customer_labour_cost"
                onChange={handleChange}
                value={String(props.workItem.estimated_customer_labour_cost)}
                disabled={props.workItem.not_being_done || props.disabled || props.quote.duplicate}
              />
              <Icon align={"left"} className={"small-icon"}>
            <FontAwesomeIcon icon={faPoundSign}/>
          </Icon>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Actual Labour Hours</Form.Label>
              <Form.Input
                data-testid="labour_hours"
                className="input"
                type="number"
                name="labour_hours"
                value={String(props.workItem.labour_hours)}
                disabled={!props.quote.duplicate}
                onChange={handleChange}
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Actual Labour Cost</Form.Label>
            <Form.Control>
              <Form.Input
                className="input"
                type="number"
                name="labour_cost"
                onChange={handleChange}
                value={String(props.workItem.labour_cost)}
                disabled={true}
              />
              <Icon align={"left"} className={"small-icon"}>
            <FontAwesomeIcon icon={faPoundSign}/>
          </Icon>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Actual Labour Charge</Form.Label>
            <Form.Control>
              <Form.Input
                className="input"
                type="number"
                name="customer_labour_cost"
                value={String(props.workItem.customer_labour_cost)}
                onChange={handleChange}
                disabled={!props.quote.duplicate}
              />
              <Icon align={"left"} className={"small-icon"}>
            <FontAwesomeIcon icon={faPoundSign}/>
          </Icon>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Workshop Invoice No</Form.Label>
            <Form.Control>
              <Form.Input
                className="input"
                type="text"
                name="job_workshop_invoice_number"
                value={props.workItem.job_workshop_invoice_number}
                disabled
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
            <WorkTypePicker
              options={props.workTypes}
              work={props.workItem}
              onSelect={handleTypeSelect}
              inlineEdit={false}
              disabled={props.workItem.not_being_done || props.quote.duplicate}
            />
        </Columns.Column>
        <Columns.Column>
          <Form.Label>Work Complete</Form.Label>
          <Form.Checkbox
            name={"complete"}
            checked={props.workItem.complete}
            onChange={handleCheck}
            disabled={!(!!props.workItem.job)}
          />
        </Columns.Column>
        <Columns.Column></Columns.Column>
        <Columns.Column></Columns.Column>
        <Columns.Column></Columns.Column>
        <Columns.Column></Columns.Column>
        <Columns.Column></Columns.Column>
        <Columns.Column></Columns.Column>
      </Columns>
      <Table size={"fullwidth"}>
        <thead>
          <tr>
            <td>Name</td>
            <td>Estimated Cost</td>
            <td>Estimated Charge</td>
            <td>Supplier</td>
            <td>Part Number</td>
            <td>Invoice No</td>
            <td>Actual Cost</td>
            <td>Actual Charge</td>
            <td>Postage</td>
            <td>Stock Accrual</td>
            <td>Backorder Date</td>
            <td>To Be Ordered</td>
            <td>Remove</td>
          </tr>
        </thead>
        <tbody data-testid="parts">
          {props.workItem.parts.map((part, index) => (
            <Part
              disabled={props.disabled}
              key={part.id || part.key}
              index={index}
              part={part}
              job={props.job}
              work={props.workItem}
              updateParts={updateParts}
              removePart={removePart}
              appDefaults={props.appDefaults}
              customer={
                props.workItem.chargeable ? props.hireCustomer : props.customer
              }
              onSearchPartClick={(part, partIndex) =>
                props.onSearchPartClick(
                  part,
                  partIndex,
                  props.index,
                  props.customer
                )
              }
            />
          ))}
        </tbody>
      </Table>
      <Button
          color="primary"
          onClick={addPart}
          data-testid="add-part"
          disabled={props.workItem.not_being_done || props.disabled}
      >
        Add Part
      </Button>
      <Columns className="is-pulled-right">
        <Columns.Column>
          <Button
            color="warning"
            data-testid="add-to-quote"
            className="is-pulled-right"
            onClick={setModifyQuoteModalOpen}
          >
            {props.additional ? "Add to Quote" : "Remove From Quote"}
          </Button>
        </Columns.Column>
        <Columns.Column>
          <Button
            color="danger"
            data-testid="remove-work"
            className="is-pulled-right remove-work"
            onClick={() => props.remove_work_item(props.index, props.workItem)}
            disabled={props.disabled}
          >
            Remove Work
          </Button>
        </Columns.Column>
      </Columns>
      <ModifyQuoteModal
        open={modifyQuoteModalOpen}
        setOpen={setModifyQuoteModalOpen}
        onAction={onToggleOriginalQuote}
      />
    </Box>
  );
}

export default WorkSection;
